import { Typography, Box } from '@mui/material';

const RoadMapEffect = () => {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexWrap: 'wrap',
        }}
      >
        <Typography
          sx={{
            color: ' #faf5ef',
            fontSize: { lg: '90px', md: '50px', sm: '40px', xs: '30px' },
            fontWeight: 400,
            lineHeight: {
              lg: '127.37px',
              md: '80.37px',
              sm: '50.37px',
              xs: '27.37px',
            },
            fontFamily: 'Chewy',
          }}
        >
          The Boring Coin:&nbsp;
        </Typography>

        <Typography
          sx={{
            color: '#faf5ef',
            fontSize: { lg: '90px', md: '50px', sm: '40px', xs: '30px' },
            fontWeight: 400,
            lineHeight: {
              lg: '127.37px',
              md: '80.37px',
              sm: '50.37px',
              xs: '50.37px',
            },
            fontFamily: 'Chewy',
          }}
        >
          Roadmap <span style={{ color: '#fff' }}>to...</span> Mediocrity
        </Typography>
      </Box>
    </>
  );
};
export default RoadMapEffect;
